import { useState, useRef, useEffect } from "react";

export function useLazyResource<T>(
    loader: () => Promise<T>,
    deps: readonly unknown[] = []
) {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const promiseRef = useRef<Promise<void> | null>(null);

    useEffect(() => {
        promiseRef.current = null;
        setData(null);
        setError(null);
        setLoading(true);

        promiseRef.current = (async () => {
            try {
                const result = await loader();
                setData(result);
            } catch (ex) {
                const message = `Failed to load resource: ${ex}`;
                console.error(message);
                setError(message);
            } finally {
                setLoading(false);
            }
        })();
    }, deps);

    return { data, loading, error, setData };
}
